import React, { forwardRef } from 'react';
import { AllieTextAreaProps, AllieTextAreaSize } from './TextArea.types';
import { StyledSpan, StyledTextArea, TextAreaWrapper } from './TextArea.styles';
import { AllieNote } from '../../Item/Note';
import { AllieCloseCircleIcon } from '../../../styling/icons';
import { AllieText } from '../../Text';
import { AllieButtonCorner } from '../../Buttons/Button/Button.types';
import { AllieInputType } from '../Input/Input.types';

const defaults: AllieTextAreaProps = {
  allieType: 'primary',
  corner: 'rounded',
  disabled: false,
  border: true,
  allieSize: 'normal',
  shadow: false,
};

export const AllieTextArea = forwardRef(
  (
    {
      allieType = defaults.allieType,
      corner = defaults.corner,
      disabled = defaults.disabled,
      border = defaults.border,
      allieSize = defaults.allieSize,
      shadow = defaults.shadow,
      onChange,
      onKeyPress,
      children,
      errorMessage,
      suffix,
      suffixAlign = 'bottom',
      ...props
    }: AllieTextAreaProps,
    ref
  ) => (
    <TextAreaWrapper className={`${suffix ? 'input-with-suffix' : ''}`}>
      <StyledTextArea
        allieType={allieType as AllieInputType}
        corner={corner as AllieButtonCorner}
        disabled={disabled as boolean}
        border={border as boolean}
        allieSize={allieSize as AllieTextAreaSize}
        shadow={shadow as boolean}
        onIonChange={onChange}
        onkeypress={onKeyPress}
        ref={ref}
        {...props}
      />
      {suffix && (
        <StyledSpan allieSize={allieSize} suffixAlign={suffixAlign}>
          {typeof suffix === 'string' ? (
            <AllieText type="body1" weight={500} color="neutral-50">
              {suffix}
            </AllieText>
          ) : (
            React.isValidElement(suffix) && suffix
          )}
        </StyledSpan>
      )}
      {errorMessage && (
        <AllieNote className="allie-text-field3" slot="error">
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              columnGap: '10px',
            }}
          >
            <AllieCloseCircleIcon color="error" />
            {errorMessage}
          </div>
        </AllieNote>
      )}
    </TextAreaWrapper>
  )
);
